import React, { useState } from 'react';
import css from './ListingPage.module.css';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { IconSpinner, InlineTextButton, NamedLink, PrimaryButton } from '../../components';
import { ReactComponent as LinkIcon } from '../../assets/svgs/linkIcon.svg';
import { ReactComponent as CopyIcon } from '../../assets/svgs/copyIcon.svg';
import { createResourceLocatorString } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

function ShareLinkBarMayBe(props) {
  const {
    rootClassName,
    className,
    listing,
    currentUser,
    id,
    onGenerateAndUpdateShareCode,
    config,
    linkGenerateInProgress,
    linkGenerateError,
    generatedShortCode,
    history,
  } = props;
  const routes = useRouteConfiguration();
  const classes = classNames(rootClassName || css.actionBar, className);
  const [markAsCopied, setMarkAsCopied] = useState(false);

  const shareCode = listing?.attributes?.publicData?.shareCode || generatedShortCode;
  const url = listing?.attributes?.publicData?.url;

  const isCTAEnabled = !!shareCode;
  const ownListingTextClasses = classNames(css.ownListingText);

  // const shareLink = typeof window !== undefined && `${window.location.href}?sh=${shareCode}`;
  const shareLink = typeof window !== undefined && `${window.location.origin}/${url}`;

  //shareLinkBarMayBe.copyLink

  return url ? (
    <div
      className={classNames(
        classes,
        {
          [css.actionBarWithCTAEnabled]: isCTAEnabled,
        },
        css.shareContainer
      )}
    >
      <p
        className={classNames(
          ownListingTextClasses,
          { [css.CTAEnabled]: isCTAEnabled },
          css.generateLinkText,
          { [css.link]: shareCode }
        )}
      >
        {shareCode ? (
          <span>{shareLink}</span>
        ) : (
          <FormattedMessage id={'shareLinkBarMayBe.generateLink'} />
        )}
      </p>
      <span className={css.btnContainer}>
        {shareCode ? (
          <>
            <CopyIcon className={css.linkIcon} />
            <InlineTextButton
              className={css.shareBtn}
              onClick={() => {
                navigator.clipboard.writeText(shareLink);
                setMarkAsCopied(true);
                setTimeout(() => {
                  setMarkAsCopied(false);
                }, 2000);
              }}
            >
              {markAsCopied ? (
                <FormattedMessage id={'shareLinkBarMayBe.copiedText'} />
              ) : (
                <FormattedMessage id={'shareLinkBarMayBe.copyText'} />
              )}
            </InlineTextButton>
          </>
        ) : linkGenerateInProgress ? (
          <div className={css.spinnerContainer}>
            <IconSpinner />
          </div>
        ) : (
          <>
            <LinkIcon className={css.linkIcon} />
            {/* <InlineTextButton
              className={css.shareBtn}
              onClick={() => {
                // onGenerateAndUpdateShareCode(id, config);
                history.push(createResourceLocatorString('ProfileSettingsPage', routes, {}, {}));
              }}
            >
              <FormattedMessage id="shareLinkBarMayBe.generateLinkBtnText" />
            </InlineTextButton> */}
            <NamedLink name="ProfileSettingsPage" params={{}} className={css.shareBtn}>
              <FormattedMessage id="shareLinkBarMayBe.generateLinkBtnText" />
            </NamedLink>
          </>
        )}
      </span>
    </div>
  ) : null;
}

export default ShareLinkBarMayBe;
